import { useMutation, useQueryClient } from "@tanstack/react-query";
import { reorderSection } from "../../services/section";

const useReorderSection = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: reorderSection,
        onSuccess: (status) => {
            if(status === 200) {
                queryClient.invalidateQueries({queryKey: ["questionnaire_content"]});
            }
        }, onError: (error) => { } 
    });
}

export default useReorderSection;